'use client';
import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import RevealStagesSection from './components/RevealStagesSection';
import ComparisonSection from './components/ComparisonSection';

const BookingSection = dynamic(() => import('./components/BookingSection'), {
  ssr: false,
  loading: () => (
    <section className="py-24 md:py-32" style={{ background: 'var(--carbon-mid)', minHeight: '600px' }} />
  ),
});

export default function HomePage() {
  // Scroll progress bar
  useEffect(() => {
    const bar = document.createElement('div');
    bar.className = 'scroll-progress';
    bar.style.width = '0%';
    document.body?.appendChild(bar);

    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement?.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = `${pct}%`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (bar?.parentNode) bar?.parentNode?.removeChild(bar);
    };
  }, []);

  return (
    <div style={{ background: 'var(--cockpit-black)', minHeight: '100vh' }}>
      <Header />
      <main>
        <HeroSection />

        {/* Section divider */}
        <div className="section-divider" />

        <RevealStagesSection />

        {/* Section divider */}
        <div className="section-divider" />

        <ComparisonSection />

        {/* Section divider */}
        <div className="section-divider" />

        <BookingSection />
      </main>
      <Footer />
    </div>
  );
}